import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { EditProgressCheckPdfScreenPath } from "./paths.ts";

export function useToEditProgressCheckPdfScreen() {
  const navigate = useNavigate();

  const toEdit = useCallback(
    (level: string, userGroupId: string) => {
      const path = EditProgressCheckPdfScreenPath.replace(
        ":level",
        encodeURIComponent(level),
      ).replace(":userGroupId", encodeURIComponent(userGroupId));
      navigate(path);
    },
    [navigate],
  );

  return { toEdit };
}
